import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e225b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-2 gradient-home-page" }
const _hoisted_2 = { class: "container pt-4" }
const _hoisted_3 = { class: "bg-white p-4 rounded" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-wrap justify-content-center gap-3\" data-v-15e225b2><div data-v-15e225b2><img src=\"/avatar.png\" style=\"width:auto;height:100px;max-width:100%;\" data-v-15e225b2></div><h3 class=\"mb-2 align-self-center text-center\" data-v-15e225b2><span class=\"fw-bold\" data-v-15e225b2>Ninja-bot</span> - бесплатный конструктор <span class=\"\" data-v-15e225b2>Telegram ботов</span> без рекламы </h3></div>", 1)
const _hoisted_5 = { class: "text-center mt-1" }
const _hoisted_6 = {
  href: "https://t.me/ninja_bot_ru",
  target: "_blank"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-4\" data-v-15e225b2><div class=\"pt-lg p-4 rounded bg-warning border-2\" data-v-15e225b2><h5 class=\"fw-bold\" data-v-15e225b2><span class=\"pi pi-exclamation-circle\" data-v-15e225b2></span> Внимание!</h5><p data-v-15e225b2> Ввод монетизации запланирован на 1 июня. Стоимость подписки составит <span class=\"fw-bold\" data-v-15e225b2>300р/мес</span> за бота. Будет доступен один тариф, который предоставляет все функции системы без ограничений. </p><p data-v-15e225b2> Для новых пользователей, добавляющих бота впервые (бот ранее не подключенный к платформе), будет предоставлен пробный период в одну неделю. </p><p data-v-15e225b2> Все существующие боты в системе перейдут на платную модель с 1 июня. Если на балансе недостаточно средств, бот будет отключен. </p></div></div>", 1)
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "bg-light pt-lg p-4 rounded" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center fw-bold" }, "Функции для Telegram групп", -1))
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6 col-lg-4 mb-2 mt-2 text-center" }
const _hoisted_14 = { class: "d-inline fw-bold" }
const _hoisted_15 = { class: "mt-2 text-muted" }
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "bg-light pt-lg p-4 rounded" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center fw-bold" }, "Функции для Telegram каналов", -1))
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6 col-lg-4 mb-2 mt-2 text-center" }
const _hoisted_22 = { class: "d-inline fw-bold" }
const _hoisted_23 = { class: "mt-2 text-muted" }
const _hoisted_24 = { class: "mt-4" }
const _hoisted_25 = { class: "bg-light pt-lg p-4 rounded" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center fw-bold" }, "Режимы работы бота в личных сообщениях", -1))
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6 col-lg-4 mb-2 mt-2 text-center" }
const _hoisted_30 = { class: "d-inline fw-bold" }
const _hoisted_31 = { class: "mt-2 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: {name: 'bots_list'} }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "Личный кабинет",
                icon: "pi pi-home",
                class: "rounded m-1"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: {name: 'doc_get_started'} }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "Документация",
                class: "rounded m-1",
                icon: "pi pi-book",
                severity: "secondary"
              })
            ]),
            _: 1
          }),
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_component_Button, {
              label: "Техническая поддержка",
              class: "rounded m-1",
              icon: "pi pi-telegram",
              severity: "secondary"
            })
          ])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.featuresForTelegramGroups, (feature) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass([feature.icon, "me-3"])
                    }, null, 2),
                    _createElementVNode("h5", _hoisted_14, _toDisplayString(feature.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(feature.description), 1)
                ]))
              }), 256))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.featuresForTelegramChannels, (feature) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass([feature.icon, "me-3"])
                    }, null, 2),
                    _createElementVNode("h5", _hoisted_22, _toDisplayString(feature.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(feature.description), 1)
                ]))
              }), 256))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.featuresForTelegramBots, (feature) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass([feature.icon, "me-3"])
                    }, null, 2),
                    _createElementVNode("h5", _hoisted_30, _toDisplayString(feature.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(feature.description), 1)
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ])
  ]))
}